import "./instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { route as routeLayout } from "./app/layout";
import { route as routeCommonLayout } from "./app/common-layout";
import { initAnalytics } from "./utils/event";
import { lazyRoute, prefetchLazyRoutes } from "@repo/ui/lib/lazy-route";
import {
  urlHome,
  urlLoadProduct,
  urlLogin,
  urlRegisterPlayer,
  urlRegisterPlayerLastName,
  urlRegisterPlayerPhone,
  urlRegisterPlayerSuccess,
  urlScanProduct,
  urlSelectCategory,
  urlSelectProduct,
  urlSuccess,
} from "./urls";

initAnalytics();

import "./index.css";

const router = createBrowserRouter([
  {
    ...routeCommonLayout,
    children: [
      { path: urlLogin(), lazy: lazyRoute(() => import("./app/login")) },
      {
        ...routeLayout,
        children: [
          { path: urlHome(), lazy: lazyRoute(() => import("./app/pages/home")) },
          {
            path: urlSelectCategory(),
            lazy: lazyRoute(() => import("./app/pages/select-category")),
          },
          {
            path: urlSelectProduct(":category"),
            lazy: lazyRoute(() => import("./app/pages/select-product")),
          },
          { path: urlSuccess(), lazy: lazyRoute(() => import("./app/pages/success")) },
          {
            path: urlScanProduct(),
            lazy: lazyRoute(() => import("./app/pages/scan-product")),
          },
          {
            lazy: lazyRoute(() => import("./app/pages/load-product/layout")),
            children: [
              {
                path: urlLoadProduct(),
                lazy: lazyRoute(() => import("./app/pages/load-product/name")),
              },
              {
                path: urlLoadProduct("price"),
                lazy: lazyRoute(() => import("./app/pages/load-product/price")),
              },
              {
                path: urlLoadProduct("sku"),
                lazy: lazyRoute(() => import("./app/pages/load-product/sku")),
              },
              {
                path: urlLoadProduct("resume"),
                lazy: lazyRoute(() => import("./app/pages/load-product/resume")),
              },
              {
                path: urlLoadProduct("category"),
                lazy: lazyRoute(() => import("./app/pages/load-product/category")),
              },
            ],
          },
          {
            path: urlRegisterPlayer(),
            lazy: lazyRoute(() => import("./app/pages/register-player/name")),
          },
          {
            path: urlRegisterPlayerLastName(),
            lazy: lazyRoute(() => import("./app/pages/register-player/last-name")),
          },
          {
            path: urlRegisterPlayerPhone(),
            lazy: lazyRoute(() => import("./app/pages/register-player/phone")),
          },
          {
            path: urlRegisterPlayerSuccess(),
            lazy: lazyRoute(() => import("./app/pages/register-player/success")),
          },
        ],
      },
    ],
  },
]);
prefetchLazyRoutes(router);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
